var _a, _b;
export var IS_SSR = !(typeof window === 'undefined');
export var HOST = process.env.NODE_ENV === 'production'
    ? IS_SSR
        ? "" + ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname.split('.').slice(-2).join('.'))
        : process.env.GATSBY_HOST || ''
    : '';
export var SUB_DOMAIN = process.env.NODE_ENV === 'production'
    ? IS_SSR
        ? "" + ((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.hostname.split('.').slice(0, -2).join('.'))
        : process.env.GATSBY_SUBDOMAIN || ''
    : '';
export var LOGIN = process.env.NODE_ENV === 'production' ? "https://login." + HOST : '';
export var API = process.env.NODE_ENV === 'production'
    ? "https://api." + HOST
    : process.env.IS_STORY == '1'
        ? '/api'
        : process.env.GATSBY_IPS_API_URL || '';
//      2 | export var HOST = process.env.NODE_ENV ===
// 'production'
//   3 |     ? IS_SSR
// > 4 |         ? "" +
// window.location.hostname.split('.').slice(-2).join('.')
